import data from "../../../../../packages/react/src/AnchoredOverlay/AnchoredOverlay.docs.json";
import DeprecationBanner from "../../../../components/DeprecationBanner";
import * as React from 'react';
export default {
  data,
  DeprecationBanner,
  React
};